export default class GlobalHandler {
	viewHeight() {
		function calculateViewHeight() {
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty("--vh", `${vh}px`);
		}
		calculateViewHeight();
		window.addEventListener("resize", () => {
			calculateViewHeight();
		});
	}
	
	headerHeight() {
		function calculateHeaderHeight() {
			const headerHeight = document.querySelector('header').offsetHeight - 1;
			document.documentElement.style.setProperty('--header-height', `${headerHeight }px`);
		}
		calculateHeaderHeight();
		window.addEventListener("resize", () => {
			calculateHeaderHeight();
		});
	}
}